import {Component, Input, OnInit, ViewChild} from '@angular/core';
import {AbstractControl, FormControl} from '@angular/forms';
import {SignaturePadControlComponent} from '../signature-pad-control/signature-pad-control.component';
export class SignaturePadCardGroupComponent implements OnInit {

  
  theme: string;

  
  group: AbstractControl;

  
  config: any;

  control: FormControl;

  
  signaturePadControl: SignaturePadControlComponent;
constructor() {

  }
/**
 * @return {?}
 */
ngOnInit() {
    this.control = /** @type {?} */(( this.group.get(this.config.name) as FormControl));
  }
/**
 * @return {?}
 */
clear() {
    this.signaturePadControl.clear();
  }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
  selector: 'signature-pad-card-group',
  template: `
    <div class="signature-pad-card" [ngClass]="theme" [formGroup]="group">

      <div class="signature-pad">
        <signature-pad-control [formControlName]="config.name" #signaturePad>
        </signature-pad-control>
      </div>
      <div class="line-break"></div>
      <div class="actions">
        <button class="clear" (click)="clear()">
          {{'Clear Signature'}}
        </button>
      </div>

      <div class="feedback">

        <!-- initial message -->
        <div *ngIf="control?.untouched && control?.pristine">Sign above!</div>

        <!-- error messages -->
        <div *ngIf="control?.dirty && control?.invalid">
          <span class="form-text text-danger" *ngFor="let error of (control?.errors | objToArray)">
           {{error.value.message}}
          </span>
        </div>

        <!-- valid message -->
        <div *ngIf="control?.dirty && control.valid">Thank you!</div>

      </div>
    </div>
  `,
  providers: []
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'theme': [{ type: Input },],
'group': [{ type: Input },],
'config': [{ type: Input },],
'signaturePadControl': [{ type: ViewChild, args: ['signaturePad', ] },],
};
}

function SignaturePadCardGroupComponent_tsickle_Closure_declarations() {
/** @type {?} */
SignaturePadCardGroupComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
SignaturePadCardGroupComponent.ctorParameters;
/** @type {?} */
SignaturePadCardGroupComponent.propDecorators;
/** @type {?} */
SignaturePadCardGroupComponent.prototype.theme;
/** @type {?} */
SignaturePadCardGroupComponent.prototype.group;
/** @type {?} */
SignaturePadCardGroupComponent.prototype.config;
/** @type {?} */
SignaturePadCardGroupComponent.prototype.control;
/** @type {?} */
SignaturePadCardGroupComponent.prototype.signaturePadControl;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
